import React from "react";
import { Button, Card, Form, Input, Tabs } from "antd";
import "swfrontend/LOGIN/LoginPage.css";
import { apiCall, localStorageVariableName, settings } from "swfrontend/AppConfigs";
import amns from "swfrontend/assets/images/amns_transparent.png";
import { post_api_login_call } from "swfrontend/COMS/Utils/ApiCommunicaton";
import { post_api_vendor_login_call } from "../VendorLogin/DataProvider"
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { notificationMessage, notificationTitle, openNotificationType } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import Modal from "react-bootstrap/Modal";
import OTPVerification from "../VendorLogin/OTPVerification/OTPVerification";

const { useState } = React;
const isIE = /*@cc_on!@*/ false || !!document.documentMode;

let username = null;
let email = null;
let duration = null;

const CommonLogin = (props) => {
    const [form] = Form.useForm();
    const [formVendor] = Form.useForm();

    const [showProgress, setProgressState] = useState(false);
    const [showOtp, setOtp] = useState(false);

    const CryptoJS = require("crypto-js");

    // Function to encrypt the password
    function encryptPassword(password, secretKey) {
        const encrypted = CryptoJS.AES.encrypt(password, secretKey).toString();
        return encrypted;
    };

    function alterUsername(username) {
        const now = new Date();
        const year = now.getFullYear();
        const date = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const pepper = `${year}${date}${month}`;
        const combined = (username + pepper).split('').reverse().join('');
        return combined;
    }

    const onDefaultFinish = (form, setProgressState) => {
        const login = prepareValues(form, setProgressState);
        if (login == null) {
            return
        }
        post_api_login_call(apiCall.login, login)
            .then((res) => {
                setProgressState(false);
                if (res.ok) {
                    res.json()
                        .then(loginAuth => {
                            localStorage.setItem(localStorageVariableName.authToken, JSON.stringify("Token " + loginAuth["Your Token"]));
                            localStorage.setItem(localStorageVariableName.userName, login.username);
                            localStorage.setItem(localStorageVariableName.isLoggedIn, true);
                            window.location.reload();
                        });
                } else {
                    res.json().then(errorResponse => {
                        if (errorResponse.hasOwnProperty('Error')) {
                            openNotification(openNotificationType.error, notificationTitle.api, errorResponse.Error);
                        }
                        else if (errorResponse.hasOwnProperty('message')) {
                            openNotification(openNotificationType.error, notificationTitle.api, errorResponse.message);
                        }
                        else {
                            openNotification(openNotificationType.error, notificationTitle.api, notificationMessage.apiConnectionError);
                        }
                    });
                }
            })
            .catch(() => {
                setProgressState(false);
                openNotification(openNotificationType.error, notificationTitle.api, notificationMessage.apiConnectionError);
            });
    };

    const prepareValues = (form, setProgressState) => {

        if (form.getFieldValue("username") !== undefined && form.getFieldValue("username") !== "" && form.getFieldValue("password") !== undefined && form.getFieldValue("password") !== "") {
            const secretKey = alterUsername(form.getFieldValue("username").toLowerCase())
            setProgressState(true);
            return {
                "username": form.getFieldValue("username").toLowerCase(),
                "password": encryptPassword(form.getFieldValue("password"), secretKey),
                "userType": "guest"
            };
        } else {
            setProgressState(false);
            return null;
        }

    };

    const onFinishVendor = () => {
        setProgressState(true);

        let data = {
            username: formVendor.getFieldValue("username"),
            userType: "guest",
        };

        post_api_vendor_login_call(`vendor/${apiCall.login}`, data)
            .then((res) => {
                if (res.ok) {
                    if (res.status === 208) {
                        openNotification("info", "OTP has been already sent");
                    } else if (res.status === 200) {
                        openNotification("info", "OTP has been sent to the email.");
                    }
                    res.json().then((loginAuth) => {
                        username = data.username;
                        email = loginAuth.mail;
                        duration = loginAuth.duration;
                        setOtp(true);
                    });
                } else {
                    res.json().then((errorResponse) => {
                        if (errorResponse.hasOwnProperty("Error")) {
                            openNotification(openNotificationType.error, errorResponse.Error);
                        } else if (errorResponse.hasOwnProperty("message")) {
                            openNotification(
                                openNotificationType.error,
                                errorResponse.message
                            );
                        } else {
                            openNotification(
                                openNotificationType.error,
                                notificationMessage.apiConnectionError
                            );
                        }
                    });
                }
            })
            .catch(() => {
                openNotification(
                    openNotificationType.error,
                    notificationMessage.apiConnectionError
                );
            })
            .finally(() => {
                setProgressState(false);
            });
    };

    return (
        <div style={{display: "grid", placeItems: "center",height: "100%"}}>
            <Modal show={showProgress} centered>
                <Modal.Body>
                    <FormLoader loading="true" />
                </Modal.Body>
            </Modal>
            <div style={{ backgroundColor: "white", width:"100%", textAlign: "center", }}>
                <img src={amns} alt="" style={{ width: "150px" }} />
            </div>

            <div style={{marginTop:"2.5rem", minWidth:"50%", textAlign:"center"}}>
                <Card  title={"Login in " + settings.appTitle} bordered={false} className={"loginCard"}>
                    <Tabs  type="card" size="middle" defaultActiveKey="amns_user_login">
                        <Tabs.TabPane tab="AMNS User" key="amns_user_login">
                            <Form
                                form={form}
                                className={"loginForm"}
                                layout={"vertical"}
                                name="basic"
                                initialValues={{
                                    username: props.username,
                                    password: props.password,
                                }}
                                onFinish={props.onFinish}
                                onFinishFailed={props.onFinishFailed}
                                autoComplete="off"
                            >
                                <Form.Item
                                    label="Username"
                                    name="username"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your username!',
                                        },
                                    ]}
                                >
                                    <Input style={{ height: "42px" }} placeholder={props.usernamePlaceholder} autoFocus={true} />
                                </Form.Item>

                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                >
                                    <Input.Password placeholder={props.passwordPlaceholder} />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType={"submit"} onClick={() => {

                                        if (props.onCustomFinish) {
                                            props.onCustomFinish(prepareValues(form, setProgressState), setProgressState);
                                        } else {
                                            onDefaultFinish(form, setProgressState)
                                        }
                                    }}>
                                        Login
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Vendor" key="vendor_login">
                            {!showOtp ? (
                                <Form
                                    form={formVendor}
                                    className="loginForm"
                                    layout="vertical"
                                    name="basic"
                                    initialValues={{
                                        username: props.username,
                                        password: props.password,
                                    }}
                                    onFinish={onFinishVendor}
                                    autoComplete="off"
                                >
                                    <p style={{ fontWeight: "bold" }}>
                                        Please input your registered email address
                                    </p>
                                    <Form.Item
                                        label="Email"
                                        name="username"
                                        validateFirst={true}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please input your email!",
                                            },
                                            {
                                                type: "email",
                                                message: "Please input a valid email address!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            disabled={showOtp}
                                            style={{ height: "42px" }}
                                            placeholder={props.usernamePlaceholder}
                                            autoFocus={true}
                                        />
                                    </Form.Item>

                                    <Form.Item>
                                        <Button type="primary" htmlType="submit">
                                            Login
                                        </Button>
                                    </Form.Item>
                                </Form>
                                // </div>
                            ) : (
                                <OTPVerification username={username} mail={email} duration={duration} />
                            )}
                        </Tabs.TabPane>
                    </Tabs>
                </Card>

            </div>
            {isIE ? (
                <p class="ie-incompaitable">
                    You are using Internet Explorer some functionality and features may
                    not work, please switch to Mozilla Firefox® 16.x or higher, Safari 5.1
                    or higher, Chrome 23 or higher, Edge 44.x or higher
                </p>
            ) : null}
            <div className={"loginFooter"}>
                <p className={"loginFooterText"}>
                    Developed and managed by AM/NS IT team
                </p>
            </div>
        </div>
    );
};

export default CommonLogin;